import {GqlClient} from '@social-native/snpkg-client-graphql-client';
import * as environmentHelper from 'js/environmentHelper';

export class GqlClientSingleton extends GqlClient {
    constructor(args){
        super(args)
    }
    static instance(config) {
        const service = (globalThis[Symbol.for(`SNPlatform_${GqlClientSingleton.name}`)] ||= new this(config));
        service.setUri(config?.uri ?? environmentHelper.graphqlGatewayUrl)
        service.setAccessToken(config?.accessToken ?? (localStorage.getItem('sn_token') || null))
        service.createClient();
        return service;
    }
}
const gqlClient = GqlClientSingleton.instance({
    enablePersistance: false
})

export default gqlClient;



// WEBPACK FOOTER //
// ./graphql/client/gqlClient.js